import { useQuery } from 'react-query';
import { QUERY_KEYS } from '../../../../../../../api/query-keys';
import { companyService } from '../../../../../../services';

export const useGetSSOSettings = () => {
  const query = useQuery({
    queryKey: QUERY_KEYS.companySSOSettings(),
    queryFn: companyService.getSSOSettings,
  });

  return query;
};
